<template style="position: relative;">
    <div>
        <img src="@/assets/img/reset-bg.png" alt="" class="bg">
        <div class="login-item">
            <div class="logo-title">
                <img src="@/assets/img/logo.png" class="logo" alt="">
                <div>- 授权管理系统 -</div>
            </div>
            <div class="login">
                <aliyun-nc></aliyun-nc>
                <div class="title">
                    <div class="title-text active" style="font-size: 18px;">找回密码</div>
                </div>
                <el-form :model="form" :rules="rules" ref="form">
                    <el-form-item prop="mobile">
                        <el-input v-model="form.mobile" placeholder="手机号"/>
                    </el-form-item>
                    <el-form-item>
                        <div id="your-dom-id" class="nc-container"></div>
                    </el-form-item>
                    <div id="hideBlock" style="display: none">
                        <el-form-item prop="validate_code">
                            <div flex="dir:left box:last" style="width: 100%">
                                <div style="margin-right: 10px">
                                    <el-input v-model="form.validate_code" placeholder="验证码"/>
                                </div>
                                <div>
                                    <el-button  class="get-code" :loading="sendingCode" :disabled="sendCodeLock" type="primary" plain
                                               @click="sendCode()">{{sendCodeLock ? '已发送' : '获取验证码'}}
                                    </el-button>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input v-model="form.password" type="password" placeholder='设置密码'/>
                        </el-form-item>
                        <el-form-item prop="confirm_password">
                            <el-input v-model="form.confirm_password" type="password" placeholder='确认密码'/>
                        </el-form-item>
                        <el-form-item>
                            <el-button :loading="loading" type="primary" @click="submit('form')">确定</el-button>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="forget">
                    <router-link to="/passport/login" class="title-text">返回登录</router-link>
                </div>
            </div>
        </div>
        <div class="foot-msg">Powered by 禾匠信息科技</div>
    </div>

    <!-- <div class="reset-password">
        <aliyun-nc></aliyun-nc>
        <h1>重置密码</h1>
        <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="form.mobile" placeholder="请输入您注册的手机号"/>
            </el-form-item>
            <el-form-item label="验证">
                <div style="color: #909090">拖动滑块完成验证</div>
                <div id="your-dom-id" class="nc-container"></div>
            </el-form-item>
            <div id="hideBlock" style="display: none">
                <el-form-item label="验证码" prop="validate_code">
                    <div flex="dir:left box:last" style="width: 100%">
                        <div style="margin-right: 10px">
                            <el-input v-model="form.validate_code" placeholder="请输入手机收到的验证码"/>
                        </div>
                        <div>
                            <el-button :loading="sendingCode" :disabled="sendCodeLock" type="primary" plain
                                       @click="sendCode()">{{sendCodeLock ? '已发送' : '获取验证码'}}
                            </el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input v-model="form.password" type="password"/>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirm_password">
                    <el-input v-model="form.confirm_password" type="password"/>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="loading" type="primary" @click="submit('form')">确定</el-button>
                </el-form-item>
            </div>
        </el-form>
    </div> -->
</template>

<style scoped>

.bg{
    width: 100%;
}

.login-item{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.logo-title{
    width: 190px;
    padding-top: 120px;
    margin: 0 auto 32px;
    font-size: 18px;
    color: #fff;
    text-align: center;
}

.logo-title .logo{
    height: 40px;
    width: 190px;
    margin-bottom: 10px;
}

.login {
    width: 280px;
    margin: 0 auto;
    padding: 45px;
    padding-left: 55px;
    border-radius: 20px;
    text-align: center;
    background-color: #fff;
}

.title {
    width: 50%;
    display: inline-block;
    text-align: center;
    margin-bottom: 38px;
    display: inline-block;
}

.title-text {
    font-size: 14px;
    color: #007bff;
}

.title .active {
    margin-bottom: 8px;
    color: #2E9FFF;
}

.active+div {
    height: 4px;
    width: 22px;
    background-color: #2E9FFF;
    margin: 0 auto;
    border-radius: 2px;
}

a {
    text-decoration:none;
}

.el-form-item{
    margin-bottom: 16px;
}

.el-button {
    width: 100%;
    margin-top: 14px;
    border-radius: 20px;
    background: linear-gradient(to right, #2E9FFF, #3E79FF);
    box-shadow: 0 4px 10px rgba(0,123,255,.5)
}

#hideBlock .get-code {
    background: #ECF5FF;
    margin-top: 0;
    font-size: 13px;
    border-color: #2e9fff;
    border-radius: 20px;
    box-shadow: none;
}

.foot-msg{
    color: #fff;
    font-size: 15px;
    width: 300px;
    text-align: center;
    margin-left: -150px;
    position: absolute;
    bottom: 75px;
    left: 50%;
}

.el-input >>> input {
    background-color: #F7F5FB;
    border-radius: 20px;
    padding-left: 20px;
    border: 0;
    color: #555555;
}

.forget{
    margin-top: 52px;
}

.login >>> .nc_wrapper {
    width: auto !important;
}

@media screen and (max-width:767px){
    .bg{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 0;
        height: 100%;
    }
    .login-item{
        height: 100%;
    }
    .login{
        height: 50%;
        width: 60%;
    }
    .logo-title{
        padding-top: 1rem;
        margin-bottom: 0.5rem;
    }
    .foot-msg{
        bottom: 1rem;
    }
}
</style>

<script>
import axios from '@/axios'

let ncData = {}

/* eslint-disable */
function aliyunNcInit() {
    let nc_token = ['FFFF0N00000000006EB0', (new Date()).getTime(), Math.random()].join(':')
    let NC_Opt =
        {
            renderTo: '#your-dom-id',
            appkey: 'FFFF0N00000000006EB0',
            scene: 'nc_message',
            token: nc_token,
            customWidth: 300,
            trans: {'key1': 'code0'},
            elementID: ['usernameID'],
            is_Opt: 0,
            language: 'cn',
            isEnabled: true,
            timeout: 3000,
            times: 5,
            apimap: {},
            callback: function (data) {
                if (data.value === 'pass') {
                    showHideBlock()
                    ncData = {
                        token: nc_token,
                        session_id: data.csessionid,
                        sig: data.sig,
                    }
                }
            }
        }
    let nc = new noCaptcha(NC_Opt)
    nc.upLang('cn', {
        _startTEXT: '请按住滑块，拖动到最右边',
        _yesTEXT: '验证通过',
        _error300: '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
    })
}

function showHideBlock() {
    document.getElementById('hideBlock').style['display'] = 'block';
}

/* eslint-enable */
export default {
    components: {
        AliyunNc: {
            render(createElement) {
                return createElement('script', {
                    attrs: {
                        type: 'text/javascript',
                        src: 'https://g.alicdn.com/sd/ncpc/nc.js?t=2015052012'
                    },
                    on: {
                        load() {
                            aliyunNcInit()
                        }
                    }
                })
            }
        }
    },
    data() {
        return {
            loading: false,
            sendingCode: false,
            sendCodeLock: false,
            form: {
                mobile: '',
                validate_code: '',
                password: '',
                confirm_password: '',
                validate_code_id: ''
            },
            rules: {
                mobile: [
                    {required: true, message: '请填写手机号。'}
                ],
                validate_code: [
                    {required: true, message: '请填写验证码。'}
                ],
                password: [
                    {required: true, message: '请填写新密码。'}
                ],
                confirm_password: [
                    {required: true, message: '请再次输入新密码。'},
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error('请再次输入新密码'))
                            } else if (value !== this.form.password) {
                                callback(new Error('两次输入密码不一致!'))
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            }
        }
    },
    created() {
    },
    methods: {
        sendCode() {
            this.sendingCode = true
            axios({
                url: 'common/send-validate-code?option=reset_password',
                method: 'post',
                data: {
                    mobile: this.form.mobile,
                    nc_data: ncData
                }
            }).then(e => {
                this.sendingCode = false
                if (e.data.code === 0) {
                    this.sendCodeLock = true
                    this.form.validate_code_id = e.data.data.id
                } else {
                    if (e.data.code === 2) {
                        /* eslint-disable */
                        ncData = {}
                        __nc.reset()
                        /* eslint-enable */
                    }
                    this.$message.error(e.data.msg)
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true
                    axios({
                        url: 'common/reset-password',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.loading = false
                        if (e.data.code === 0) {
                            this.$alert(e.data.msg, '提示', {
                                callback: action => {
                                    this.$router.push('/passport/login')
                                }
                            })
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                } else {
                }
            })
        }
    }
}
</script>
